export const noAdminProjectStatuses = [1, 3, 6, 7];
